/** `publicview` translations: the public view share link, its admin panel and the page it opens. */
export const publicView = {
  mn: {
    publicview: {
      panelTitle: 'Нийтийн харах холбоос',
      panelHint:
        'Холбоостой хэн ч нэвтрэхгүйгээр хянах самбар, компанийн хуанли болон зохион байгуулалтын бүдүүвчийг (зөвхөн нэр, албан тушаал) харна. Шинэ холбоос үүсгэхэд хуучин нь хүчингүй болно.',
      labelField: 'Шошго (заавал биш)',
      labelPlaceholder: 'жишээ нь: Үүдний дэлгэц',
      expiresField: 'Хүчинтэй хугацаа (хоног)',
      create: 'Холбоос үүсгэх',
      regenerate: 'Холбоосыг солих',
      regenerateConfirm: 'Солиход одоогийн холбоос болон түүнийг ашиглаж буй бүх дэлгэц хаагдана. Үргэлжлүүлэх үү?',
      createdTitle: 'Энэ холбоосыг одоо хуулна уу',
      createdHint:
        'Зөвхөн нэг удаа харагдана. Хугацаа нь дуусах эсвэл цуцлагдах хүртэл холбоостой хэн ч нийтийн харагдацыг нээж чадна.',
      copy: 'Хуулах',
      copied: 'Холбоос хуулагдлаа',
      copyFailed: 'Хуулж чадсангүй — холбоосыг сонгоод гараар хуулна уу.',
      revoke: 'Цуцлах',
      revokeConfirm: 'Энэ холбоосыг цуцлах уу? Түүнийг ашиглаж буй бүх дэлгэц гарна.',
      revoked: 'Холбоос цуцлагдлаа',
      statusLive: 'Идэвхтэй',
      statusRevoked: 'Цуцлагдсан',
      statusExpired: 'Хугацаа дууссан',
      empty: 'Холбоос алга.',
      expiresOn: '{{date}} хүртэл',
      createdBy: '{{name}}',
      loadError: 'Холбоосуудыг ачаалж чадсангүй.',
      createFailed: 'Холбоос үүсгэж чадсангүй: {{reason}} Дахин оролдоно уу.',
      revokeFailed: 'Холбоосыг цуцалж чадсангүй: {{reason}} Дахин оролдоно уу.',
      opening: 'Нийтийн харагдацыг нээж байна…',
      openFailed:
        'Энэ холбоос хүчингүй байна. Хугацаа нь дууссан эсвэл солигдсон байж магадгүй — хуваалцсан хүнээсээ шинийг аваарай.',
      headcount: 'Ажилтан',
      teams: 'Багууд',
      desksFree: 'Өнөөдөр сул ширээ',
      desksBooked: 'Өнөөдөр захиалсан ширээ',
      dashboardError: 'Хянах самбарыг ачаалж чадсангүй.',
    },
  },
  en: {
    publicview: {
      panelTitle: 'Public view link',
      panelHint:
        'Anyone with the link sees the dashboard, the company calendar and the org chart (names and titles only), with no sign-in. Making a new link ends the old one.',
      labelField: 'Label (optional)',
      labelPlaceholder: 'e.g. Lobby screen',
      expiresField: 'Expires after (days)',
      create: 'Create link',
      regenerate: 'Replace link',
      regenerateConfirm: 'Replacing ends the current link and every screen using it. Continue?',
      createdTitle: 'Copy this link now',
      createdHint:
        'It is shown only once. Anyone holding it can open the public view until it expires or is revoked.',
      copy: 'Copy',
      copied: 'Link copied',
      copyFailed: 'Could not copy — select the link and copy it by hand.',
      revoke: 'Revoke',
      revokeConfirm: 'Revoke this link? Every screen using it signs out.',
      revoked: 'Link revoked',
      statusLive: 'Live',
      statusRevoked: 'Revoked',
      statusExpired: 'Expired',
      empty: 'No link yet.',
      expiresOn: 'Expires {{date}}',
      createdBy: 'by {{name}}',
      loadError: 'Could not load the links.',
      createFailed: 'Could not create the link: {{reason}} Try again.',
      revokeFailed: 'Could not revoke the link: {{reason}} Try again.',
      opening: 'Opening the public view…',
      openFailed:
        'This link is not valid. It may have expired or been replaced — ask whoever shared it for a new one.',
      headcount: 'People',
      teams: 'Teams',
      desksFree: 'Desks free today',
      desksBooked: 'Desks booked today',
      dashboardError: 'Could not load the dashboard.',
    },
  },
  ru: {
    publicview: {
      panelTitle: 'Публичная ссылка для просмотра',
      panelHint:
        'Любой, у кого есть ссылка, видит панель, календарь компании и оргструктуру (только имена и должности) без входа. Новая ссылка отменяет старую.',
      labelField: 'Метка (необязательно)',
      labelPlaceholder: 'например: экран в холле',
      expiresField: 'Срок действия (дней)',
      create: 'Создать ссылку',
      regenerate: 'Заменить ссылку',
      regenerateConfirm: 'Замена отменит текущую ссылку и отключит все экраны, которые её используют. Продолжить?',
      createdTitle: 'Скопируйте ссылку сейчас',
      createdHint:
        'Она показывается только один раз. Любой, у кого она есть, может открыть публичный просмотр, пока срок не истёк или ссылка не отозвана.',
      copy: 'Копировать',
      copied: 'Ссылка скопирована',
      copyFailed: 'Не удалось скопировать — выделите ссылку и скопируйте вручную.',
      revoke: 'Отозвать',
      revokeConfirm: 'Отозвать эту ссылку? Все экраны, которые её используют, выйдут.',
      revoked: 'Ссылка отозвана',
      statusLive: 'Активна',
      statusRevoked: 'Отозвана',
      statusExpired: 'Истекла',
      empty: 'Ссылки пока нет.',
      expiresOn: 'До {{date}}',
      createdBy: '{{name}}',
      loadError: 'Не удалось загрузить ссылки.',
      createFailed: 'Не удалось создать ссылку: {{reason}} Повторите попытку.',
      revokeFailed: 'Не удалось отозвать ссылку: {{reason}} Повторите попытку.',
      opening: 'Открываем публичный просмотр…',
      openFailed:
        'Ссылка недействительна. Возможно, срок истёк или её заменили — попросите новую у того, кто ею поделился.',
      headcount: 'Сотрудники',
      teams: 'Команды',
      desksFree: 'Свободных столов сегодня',
      desksBooked: 'Забронировано столов сегодня',
      dashboardError: 'Не удалось загрузить панель.',
    },
  },
}
